import sdk from "@/genuinevendor-sdk";

// initial state
const boilerplate = {
  all: [],
  sdkerror: ""
};

/*const state = () => ({
  id: "5d582c7da3843b00177d1aa1",
  list: "730",
  sub: "7302",
  friendlyname: "Kiuruveden lukio",
  htmlname: "Kiuruveden lukio",
  cat: "kiuruvesi",
  customer: "student",
  createdAt: "2019-08-17T16:34:05.798Z",
  updatedAt: "2019-08-17T16:34:05.798Z",
  all: [],
  sdkerror: ""
});*/
const state = () => ({
  all: [],
  sdkerror: ""
});

const actions = {
  async getListinfos({ commit }) {
    try {
      let lists = await sdk.getListinfos();
      commit("setAllLists", lists);
    } catch (e) {
      console.log(e);
      commit("errorOccured", e);
    }
  },
  async chooseList({ commit }, query) {
    try {
      const lists = await sdk.getListinfos();
      let chosenList = lists.find(x => x.sub == query);
      if (chosenList) commit("setCurList", chosenList);
      else commit("errorOccured", new Error("No such list"));
    } catch (e) {
      console.log(e);
      commit("errorOccured", e);
    }
  }
};

const mutations = {
  errorOccured(state, e) {
    //state = { ...boilerplate };
    Object.assign(state, boilerplate);
    typeof e === "object" ? (state.sdkerror = e.message) : (state.sdkerror = e);
  },
  setAllLists(state, pl) {
    state.all = [...pl];
  },
  setCurList(state, pl) {
    console.log(pl);
    Object.assign(state, pl);
  }
};

export default {
  namespaced: true,
  state,
  actions,
  mutations
};
